const vttMode = "hidden"; // "showing" // "hidden"
const thumbnailPath = "/mymystar/reel/img/";
const cuepointFile = "/mymystar/js/cuepoints.json"

import $ from "jquery";

class Caption {
  constructor(config) {
    this.id = config.id;
    this.client = config.client;
    this.title = config.title;
    this.info = config.info;
    this.thumbnail = `${thumbnailPath}${config.thumbnail}`;
    this.url = config.url;
  }
}

let video; //  = document.querySelector("video");
let vtt;
let activeCueID = "";
let prevCueID = "";
let captions = {};

function setupCaptions() {
  vtt = video[0].textTracks[0];
  $.getJSON(cuepointFile, (cuepoints) => {
    console.log(`${cuepointFile}:loaded`);
    let thumbs = [];
    for (let cue of cuepoints) {
      let uuid = uuidv4();
      cue.id = uuid;
      let caption = new Caption(cue);
      captions[uuid] = caption;
      let startTime = timeCodeToDecimal(cue.start);
      let endTime = timeCodeToDecimal(cue.end);
      let newCue = new VTTCue(startTime, endTime, uuid);
      newCue.id = uuid;
      thumbs.push(caption.thumbnail);
      vtt.addCue(newCue);
    }
    vtt.mode = vttMode;

    // preload images
    preload(thumbs);
    vtt.addEventListener("cuechange", handleCueChange, false);
  });

}

function preload(arrayOfImages) {
  for (var src of arrayOfImages) {
    $('<img />').attr('src', src).appendTo('body').hide()
  }
}

function timeCodeToDecimal(timecode) {
  let parts = timecode.split(":");
  let hours = parseInt(parts[0]) * 60 * 60;
  let minutes = parseInt(parts[1]) * 60;
  let seconds = parseFloat(parts[2])
  let total = hours + minutes + seconds;
  return (total);
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function handleCueChange(event) {
  var newCueID;
  prevCueID = activeCueID;
  if (vtt.activeCues.length > 0) {
    newCueID = vtt.activeCues[0].id;
    handleCueStart(newCueID)
    activeCueID = newCueID;
  } else if (vtt.activeCues.length == 0 && prevCueID !== "") {
    handleCueComplete(activeCueID);
  }
}

function handleLoopRestart(event) {
  handleCueComplete(activeCueID);
  video[0].play();
}

function handleCueStart(id) {
  for (let idx = 0; idx < $('*[id=video-caption]').length; idx++) {
    $('*[id=video-caption]')[idx].style.visibility = "visible";
    var caption = captions[id];
    $('*[id=video-caption-client]')[idx].innerHTML = caption.client + '<span id="video-caption-title-slash">/</span>';
    $('*[id=video-caption-title]')[idx].innerHTML = caption.title;
    $('*[id=video-caption-info]')[idx].innerHTML = (caption.info) ? caption.info : "&nbsp;";
    let thumb = $('*[id=video-caption-thumbnail]')[idx];
    let thumbButton = $('*[id=video-caption-thumbnail-button]')[idx];
    if (caption.thumbnail) {
      thumb.src = caption.thumbnail;
      thumb.style.visibility = "visible";
      if (getComputedStyle(thumbButton, null).display === 'block') {
        thumbButton.style.visibility = "visible";
      }
    } else {
      thumb.style.visibility = "hidden";
      thumbButton.style.visibility = "hidden";
    }
    $('*[id=video-caption-link]')[idx].href = (caption.url) ? caption.url : "#";
  }
}

function handleCueComplete(id) {
  activeCueID = "";
  for (let idx = 0; idx < $('*[id=video-caption]').length; idx++) {
    $('*[id=video-caption]')[idx].style.visibility = "hidden";
    $('*[id=video-caption-client]')[idx].innerHTML = "";
    $('*[id=video-caption-title]')[idx].innerHTML = "";
    $('*[id=video-caption-info]')[idx].innerHTML = "";
    $('*[id=video-caption-thumbnail]')[idx].src = "";
    $('*[id=video-caption-thumbnail]')[idx].style.visibility = "hidden";
    $('*[id=video-caption-thumbnail-button]')[idx].style.visibility = "hidden";
    $('*[id=video-caption-link]')[idx].href = "#";
  }

}


$(() => {
  if (window.location.pathname === '/') {
    video = $("video");
    if (video[0]) {
      setupCaptions();
      video[0].addEventListener('ended', handleLoopRestart, false);
    } else {
      console.log('video missing');
    }
  }
});